<form #form="ngForm" autocomplete="off" class="md:w-72" novalidate [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <div class="flex flex-col">
    <mat-form-field class="gt-xs:pr-3 flex-auto" [floatLabel]="'always'">
      <mat-label>{{ "CURRENT_PASSWORD_LABEL" | translate }}</mat-label>

      <input class="form-control" matInput type="password" [formControlName]="FormKeys.CURRENT_PASSWORD" />

      @if (controlHasError(FormKeys.CURRENT_PASSWORD)) {
        <mat-error>
          {{ "ERROR_PASSWORD_REQUIRED" | translate }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <ic-new-password-fields-section class="mt-2 flex flex-col gap-2" [controlHasErrorFn]="controlHasError.bind(this)" />

  <div class="mt-4">
    <button
      class="w-full md:w-auto md:min-w-48"
      color="primary"
      mat-raised-button
      type="submit"
      [disabled]="formGroup.invalid"
    >
      <mat-icon>check</mat-icon>
      {{ "CHANGE_PASSWORD" | translate }}
    </button>
  </div>
</form>
